<template>
  <div>
    <vxe-table
        class="table-style"
        stripe
        align="center"
        highlight-hover-row
        border="inner"
        :loading="loading"
        :data="rec"
        height="550"
    >
      <vxe-table-column field="createUser" title="操作人" show-overflow></vxe-table-column>
      <vxe-table-column field="createTime" title="操作时间" show-overflow></vxe-table-column>
      <vxe-table-column field="" title="校验记录" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.msg }}</span>
          <span v-if="row.msg.indexOf('失败') > -1" style="cursor: pointer;color: #5faeff;margin-left: 20px"
                @click="openDetail(row)">失败详情</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-modal v-model="detailModal" title="详情" width="1000" height="620" resize position="center">
      <import-record-detail ref="recDetail"></import-record-detail>
    </vxe-modal>
  </div>
</template>
<script>
import $api from '@/apiProvider';
import ImportRecordDetail from "@/views/user/ImportRecordDetail";

export default {
  components: {ImportRecordDetail},
  data() {
    return {
      rec: [],
      loading: false,
      detailModal: false
    }
  },
  methods: {
    init() {
      this.queryUserErrorList();
    },
    async queryUserErrorList() {
      let res = await $api.gcdUser.get("queryUserErrorList");
      if (res.status === 1) {
        this.rec = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openDetail(row) {
      this.detailModal = true;
      this.$nextTick(() => {
        this.$refs.recDetail.init(row);
      })
    }
  }
}
</script>
<style>

</style>